import exceptionTaskApi from "@/api/exceptionTaskApi";

const exceptionTaskStore = {
  state: {
    declareList: [],
  },
  mutations: {
    setDeclareList(state, data) {
      state.declareList = data;
    },
  },
  actions: {
    exceptionTaskList({ commit }, data) {
      return exceptionTaskApi.exceptionTaskList(data).then((res) => {
        //commit("setDeclareList", res.result);
        return res;
      });
    },
    traceDetail({ commit }, data) {
      return exceptionTaskApi.traceDetail(data).then((res) => {
        return res;
      });
    },
    reException({ commit }, data) {
      return exceptionTaskApi.reException(data).then((res) => {
        return res;
      });
    },
  },
};

export default exceptionTaskStore;
